import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserInputMismatch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 148,
	height: 133,
	viewBox: "0 0 148 133",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M93.4241 17.5711C58.645 0.227556 16.9315 30.0448 7.27647 54.6395C-15.9076 113.697 24.6074 140.952 42.4307 130.983C49.8713 126.821 55.9491 119.714 61.8231 112.799C70.643 102.505 82.3287 96.573 94.5828 96.1689C104.02 95.9066 113.413 98.9685 122.823 98.0694C132.234 97.1704 140.546 81.4783 140.291 70.0689C139.902 52.6547 130.719 36.1685 93.4241 17.5711Z",
			fill: "#FFF2F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.1462 95.7812H52.7266V109.805H88.1462V95.7812Z",
			fill: "#0DC277",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.344 96.4049C20.8713 96.37 18.4094 95.4353 16.5205 93.5997C12.6652 89.853 12.659 83.7719 16.5069 80.0177L48.5017 48.7531C52.3496 44.9988 58.5935 44.9931 62.4492 48.7398C66.3045 52.4865 66.3107 58.5675 62.4628 62.3218L30.4681 93.5864C28.5056 95.5013 25.9184 96.4412 23.344 96.4049Z",
			fill: "#0DC277",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.3761 40.7657C53.9263 40.7862 50.1738 41.5256 45.9806 44.4339C43.6974 46.0175 35.0928 55.57 33.3167 57.5523L32.8672 57.8995L46.445 60.6042C46.445 60.6042 51.5835 51.4432 52.5881 50.2197C54.3537 48.0687 55.9619 46.2229 54.9694 45.8101C53.9769 45.3974 53.2257 46.0588 51.8143 47.349C46.7532 51.9761 47.2184 48.1112 47.2289 47.9891C47.246 47.7856 49.3677 45.4611 49.9106 45.1082C51.849 43.8472 53.3397 43.0512 55.6381 41.9941C56.1698 41.7496 56.0573 40.7562 55.3765 40.7657H55.3761Z",
			fill: "white",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.5156 58.1758L46.9716 58.1683L50.5723 50.4703L46.7921 44.9805L36.6333 54.6335L33.5156 58.1758Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.6371 44.0078C49.6371 44.0078 51.2691 44.6794 52.3811 45.2954C52.965 45.6187 53.8664 47.399 54.0583 47.8932C54.7165 49.5897 53.8937 49.8857 52.958 49.1409C52.0787 48.4409 51.8389 47.6351 50.9336 47.087C50.089 46.5757 47.7812 46.2767 47.7812 46.2767",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.6371 44.0078C49.6371 44.0078 51.2691 44.6794 52.3811 45.2954C52.965 45.6187 53.8664 47.399 54.0583 47.8932C54.7165 49.5897 53.8937 49.8857 52.958 49.1409C52.0787 48.4409 51.8389 47.6351 50.9336 47.087C50.089 46.5757 47.7812 46.2767 47.7812 46.2767",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.8359 45.2305C47.8359 45.2305 49.6664 46.1523 50.7154 46.8951C51.2587 47.2799 51.9644 48.9586 52.0357 49.4824C52.145 50.2863 52.0205 50.6953 51.4211 50.6755C50.5656 50.6475 50.1506 48.9328 49.2457 48.3847C48.401 47.8734 45.9766 46.7098 45.9766 46.7098",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.8359 45.2305C47.8359 45.2305 49.6664 46.1523 50.7154 46.8951C51.2587 47.2799 51.9644 48.9586 52.0357 49.4824C52.145 50.2863 52.0205 50.6952 51.4211 50.6755C50.5656 50.6475 50.1506 48.9328 49.2457 48.3847C48.401 47.8734 45.9766 46.7098 45.9766 46.7098",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.0037 47.7539C49.3201 48.9986 49.2181 49.8264 49.2076 50.2642C49.1893 51.009 48.6627 51.1883 48.2162 50.8225C47.6226 50.3362 46.8524 49.2973 46.467 49.1025C45.6672 48.6977 44.25 48.3323 44.25 48.3323",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.864 52.7656L14.2783 81.5651C12.7599 83.6399 12.0885 86.3355 12.6852 89.022C13.81 94.0843 18.9357 97.2999 24.1343 96.2045L24.6986 96.0855",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6674 96.2183L24.103 96.3374C18.9045 97.4327 13.7788 94.2167 12.6539 89.1548C12.0572 86.4683 12.7286 83.7727 14.247 81.6979L34.8328 52.8984L48.8041 61.5046L34.8542 82.5098",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6674 96.2183L24.103 96.3374C18.9045 97.4327 13.7788 94.2167 12.6539 89.1548C12.0572 86.4683 12.7286 83.7727 14.247 81.6979L34.8328 52.8984L48.8041 61.5046L34.8542 82.5098",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.4756 45.9688L89.5193 46.0218C95.1588 46.0423 98.9141 49.6589 99.373 53.11C99.8957 57.0431 96.6822 60.8864 96.6908 61.1589C96.8153 65.0758 96.1019 100.826 96.1019 100.826L48.6875 100.064L49.7649 63.7837",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.4756 45.9688L89.5193 46.0218C95.1588 46.0423 98.9141 49.6589 99.373 53.11C99.8957 57.0431 96.6822 60.8864 96.6908 61.1589C96.8154 65.0758 96.1019 100.826 96.1019 100.826L48.6875 100.064L49.7649 63.7837",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0625 109.981C17.0196 108.968 22.6918 112.85 23.7318 118.65C24.7718 124.451 20.7858 129.975 14.829 130.988",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7344 111.35C21.4745 112.502 23.2941 111.633 26.2121 111.137L28.6798 124.9C25.7618 125.396 22.8472 125.584 20.629 127.496",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1719 111.715C19.1719 111.715 26.6042 116.485 21.9046 126.614",
			stroke: "white",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4531 106.514L108.259 88.7599C116.717 87.2237 124.853 92.6551 126.43 100.891C128.008 109.128 122.43 117.05 113.972 118.586C113.622 118.649 28.1045 130.187 28.1045 130.187L24.4531 106.515",
			fill: "#787878"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4531 106.514L108.259 88.7599C116.717 87.2237 124.853 92.6551 126.43 100.891C128.008 109.128 122.43 117.05 113.972 118.586C113.622 118.649 28.1045 130.187 28.1045 130.187L24.4531 106.515",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.701 131.488C114.904 130.162 111.309 124.51 112.671 118.866C114.033 113.221 119.836 109.72 125.633 111.046",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.2 127.732C112.27 125.281 110.277 125.382 107.438 124.733L110.669 111.34C113.509 111.989 116.222 112.917 118.991 112.021",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.048 126.865C114.048 126.865 109.753 116.646 117.491 112.344",
			stroke: "white",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.631 130.978C109.631 130.978 25.3747 119.956 25.0299 119.894C16.695 118.415 11.1699 110.637 12.6887 102.52C14.2078 94.4037 22.1955 89.0235 30.5304 90.5024L113.128 107.653L109.632 130.978L109.631 130.978Z",
			fill: "#787878",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.7049 30.1773C77.3937 30.1773 82.8161 24.8971 82.8161 18.3836C82.8161 11.8701 77.3937 6.58984 70.7049 6.58984C64.0161 6.58984 58.5938 11.8701 58.5938 18.3836C58.5938 24.8971 64.0161 30.1773 70.7049 30.1773Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.7812 29.3702C81.6491 29.3129 83.1154 27.7722 83.0558 25.929C82.999 24.165 81.5643 22.7668 79.8038 22.6997C78.3252 16.7892 73.206 12.4077 66.7924 12.604C61.9703 12.7518 60.2923 15.3281 58.0679 19.1805C56.8909 21.2192 57.4089 33.0588 59.0721 35.5748C60.1841 37.2573 62.1473 38.3675 65.2927 38.8185L65.5434 45.716C65.5434 45.716 65.2164 52.1424 72.693 51.9172C81.1307 51.6633 80.0981 44.9943 80.0981 44.9943C80.0981 44.9943 79.4901 30.1794 79.7162 29.3694C79.738 29.3694 79.7591 29.3713 79.7809 29.3706L79.7812 29.3702Z",
			fill: "white",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.0312 18.1718L73.9122 17.9406C73.9122 17.9406 72.9898 22.4805 77.3293 24.4299L78.0279 27.6148L79.4369 27.5716L80.1107 22.2622L78.6733 10.854L68.2365 7.70312L57.6675 11.4972L55.032 18.1718H55.0312Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.9304 21.2743C60.2585 21.2743 63.7671 17.8576 63.7671 13.643C63.7671 9.42836 60.2585 6.01172 55.9304 6.01172C51.6024 6.01172 48.0938 9.42836 48.0938 13.643C48.0938 17.8576 51.6024 21.2743 55.9304 21.2743Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.7054 16.1419C68.4432 16.1419 71.4732 13.1912 71.4732 9.55142C71.4732 5.9116 68.4432 2.96094 64.7054 2.96094C60.9676 2.96094 57.9375 5.9116 57.9375 9.55142C57.9375 13.1912 60.9676 16.1419 64.7054 16.1419Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.3672 38.818C65.3672 38.818 68.5752 39.3838 71.6372 37.4648L65.3672 38.818Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.3672 38.818C65.3672 38.818 68.5752 39.3838 71.6372 37.4648",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.0813 25.4109L69.0743 25.3541C69.0774 25.2756 69.0607 25.2028 69.0241 25.135C69.0008 25.0645 68.9603 25.0035 68.9035 24.9519C68.8505 24.8966 68.7878 24.8571 68.7154 24.8344C68.6458 24.7988 68.5711 24.7825 68.4905 24.7855L68.3352 24.806C68.2363 24.8329 68.1503 24.8818 68.0775 24.9523L67.986 25.0675C67.9331 25.1562 67.9066 25.2517 67.9062 25.3544L67.9133 25.4113C67.9101 25.4897 67.9269 25.5625 67.9635 25.6304C67.9868 25.7009 68.0273 25.7619 68.0841 25.8134C68.1371 25.8688 68.1997 25.9082 68.2721 25.9309C68.3418 25.9666 68.4165 25.9829 68.4971 25.9798L68.6524 25.9594C68.7513 25.9324 68.8373 25.8835 68.9101 25.813L69.0015 25.6978C69.0545 25.6091 69.0809 25.5136 69.0813 25.4109Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.0501 25.9695L62.0431 25.9126C62.0462 25.8342 62.0294 25.7614 61.9929 25.6936C61.9695 25.6231 61.929 25.5621 61.8722 25.5105C61.8193 25.4552 61.7566 25.4157 61.6842 25.393C61.6145 25.3574 61.5398 25.3411 61.4592 25.3441L61.3039 25.3646C61.2051 25.3915 61.119 25.4404 61.0463 25.5109L60.9548 25.6261C60.9019 25.7148 60.8754 25.8103 60.875 25.913L60.882 25.9699C60.8789 26.0483 60.8956 26.1211 60.9322 26.189C60.9556 26.2595 60.9961 26.3205 61.0529 26.372C61.1058 26.4274 61.1685 26.4668 61.2409 26.4895C61.3105 26.5251 61.3853 26.5414 61.4658 26.5384L61.6211 26.5179C61.72 26.491 61.806 26.4421 61.8788 26.3716L61.9703 26.2564C62.0232 26.1677 62.0497 26.0722 62.0501 25.9695Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.564 27.3711L63.2352 28.9895C63.1744 29.2882 63.4449 29.5512 63.7516 29.4921L65.2097 29.2094",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.564 27.3711L63.2352 28.9895C63.1744 29.2882 63.4449 29.5512 63.7516 29.4921L65.2097 29.2094",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.0859 21.5964C67.0859 21.5964 69.1772 20.8456 70.278 22.1854L67.0859 21.5964Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.0859 21.5964C67.0859 21.5964 69.1772 20.8456 70.278 22.1854",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1094 23.3509C59.1094 23.3509 60.518 21.6688 62.1656 22.2771L59.1094 23.3509Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1094 23.3509C59.1094 23.3509 60.518 21.6688 62.1656 22.2771",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.6324 37.4648L65.5017 44.4192L65.3125 39.0351C65.3125 39.0351 67.2018 39.012 69.0689 38.4598C70.9364 37.9075 71.6324 37.4648 71.6324 37.4648Z",
			fill: "#3C3C3C",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.8535 31.4677C68.8535 31.4677 66.7216 30.2504 65.9219 32.2791L68.8535 31.4677Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.8535 31.4677C68.8535 31.4677 66.7216 30.2504 65.9219 32.2791",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.6484 64.5786L107.11 93.585C109.072 95.4999 111.66 96.4399 114.234 96.4035C116.707 96.3686 119.169 95.4339 121.057 93.5983C124.913 89.8516 124.886 85.1191 121.071 80.0163L97.4964 49.3047",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.6484 64.5786L107.11 93.585C109.072 95.4999 111.66 96.4399 114.234 96.4035C116.707 96.3686 119.169 95.4339 121.057 93.5983C124.913 89.8516 124.886 85.1191 121.071 80.0163L97.4964 49.3047",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.4077 67.2545C83.3602 66.6618 83.2812 66.0815 83.2441 65.544C83.1372 64.0102 83.3571 62.8275 84.1237 62.743C86.1969 62.5144 88.4301 66.8581 90.7572 71.5614L86.1747 75.3187L83.4077 67.2545Z",
			fill: "#FFFDFD",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.282 74.7422L90.6538 65.8403L82.0368 81.0455L111.277 95.6726C113.447 96.6889 115.906 96.5811 118.109 95.5858C120.224 94.6297 122.102 92.8557 123.26 90.4725",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.282 74.7422L90.6538 65.8403L82.0368 81.0455L111.277 95.6726C113.447 96.6889 115.906 96.5811 118.109 95.5858C120.224 94.6297 122.102 92.8557 123.26 90.4725",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.1971 74.3818L84.5342 54.6193C84.508 53.8371 83.8468 53.2178 83.0431 53.2227L74.724 53.2712C73.8962 53.2761 73.2325 53.9402 73.2504 54.7463L73.6852 74.3454C73.7027 75.1228 74.349 75.7473 75.1473 75.7582L83.6943 75.873C84.5404 75.8844 85.2249 75.2049 85.1971 74.3818Z",
			fill: "#A0A0A0",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.4782 56.0029C82.9753 56.0029 83.3782 55.6105 83.3782 55.1265C83.3782 54.6424 82.9753 54.25 82.4782 54.25C81.9811 54.25 81.5781 54.6424 81.5781 55.1265C81.5781 55.6105 81.9811 56.0029 82.4782 56.0029Z",
			fill: "white",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.4453 72.7027L85.1361 66.2868C85.1361 66.2868 74.5238 61.7654 73.6813 61.6949C72.6091 61.6056 72.1277 63.2611 72.8886 63.8339C73.3047 64.1474 73.8502 64.3333 74.2521 64.4857C73.4333 64.1686 72.8809 64.679 72.6295 65.2823C72.1702 66.3863 73.5667 66.9717 73.7266 67.056C72.4252 67.056 71.9143 68.4804 73.1546 69.3279C73.2366 69.3838 73.4018 69.46 73.4973 69.5049C73.3761 69.6402 72.818 69.639 72.7046 70.6145C72.6047 71.4718 73.5295 71.8534 73.942 72.1237C74.4303 72.4437 83.753 77.4219 83.753 77.4219L86.4453 72.7027Z",
			fill: "#FFFDFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.3123 64.3881C73.9007 64.2231 73.2345 64.0321 72.7448 63.6726C71.9702 63.1043 72.4603 61.4614 73.5518 61.5504C74.41 61.6199 85.2136 66.1062 85.2136 66.1062",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.4671 66.2344L74.1367 64.3192C73.3027 64.0042 72.7399 64.5105 72.4844 65.1092C72.0167 66.2044 73.4385 66.7852 73.6013 66.869C72.2764 66.869 71.7563 68.2822 73.019 69.123C73.1025 69.1785 73.2703 69.2541 73.3679 69.2986C73.2445 69.4329 72.6763 69.4316 72.5609 70.3995C72.4591 71.2501 73.4007 71.6287 73.8206 71.8969C74.6393 72.4202 83.7518 77.4225 83.7518 77.4225",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.4609 66.7891L77.7453 68.5206",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.25 69.2461L77.1152 70.9744",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.201 38.9137C111.201 38.9137 110.167 43.1954 106.447 46.1693C101.041 50.4917 90.811 47.4734 87.6157 53.5527C86.9891 54.7449 86.5426 56.8207 86.5426 56.8207",
			stroke: "#646464",
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.935 34.0777L100.693 39.7962C99.9384 39.9893 99.138 39.8756 98.4673 39.4803C97.7966 39.0849 97.3104 38.44 97.1153 37.6872L90.389 11.6069C90.1956 10.8536 90.3094 10.0545 90.7054 9.38485C91.1014 8.71522 91.7473 8.22977 92.5013 8.03499L113.194 2.71484L118.49 5.08201L125.048 30.5057C125.241 31.259 125.127 32.0581 124.731 32.7278C124.335 33.3974 123.689 33.8829 122.935 34.0777Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.7066 8.852C92.1696 8.9907 91.7097 9.33639 91.4277 9.81324C91.1456 10.2901 91.0646 10.8591 91.2023 11.3956L97.929 37.476C98.068 38.0121 98.4142 38.4713 98.8918 38.7529C99.3694 39.0345 99.9394 39.1154 100.477 38.9779L122.719 33.2595C123.256 33.1208 123.716 32.7751 123.998 32.2982C124.28 31.8214 124.361 31.2523 124.223 30.7159L117.768 5.68588L113.113 3.60547L92.7066 8.852Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.431 5.21718L114.989 6.10222C114.737 6.16681 114.471 6.1291 114.247 5.99737C114.024 5.86564 113.862 5.65068 113.797 5.39978L113.143 2.86137C113.14 2.85027 113.14 2.83858 113.144 2.82766C113.147 2.81674 113.154 2.80702 113.162 2.79961C113.171 2.7922 113.182 2.78741 113.193 2.78578C113.204 2.78415 113.216 2.78574 113.227 2.79038L118.441 5.10226C118.452 5.10741 118.462 5.11604 118.468 5.12694C118.475 5.13785 118.478 5.15049 118.477 5.16312C118.476 5.17575 118.471 5.18774 118.463 5.19742C118.454 5.20711 118.443 5.21401 118.431 5.21718Z",
			fill: "#787878"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.618 27.4895L106.491 30.0933C106.366 30.1248 106.233 30.1054 106.122 30.0395C106.011 29.9735 105.931 29.8664 105.898 29.7414C105.866 29.6164 105.885 29.4837 105.95 29.3724C106.015 29.2611 106.122 29.1802 106.247 29.1473L116.374 26.5435C116.436 26.5271 116.501 26.5231 116.565 26.5319C116.629 26.5406 116.691 26.5619 116.746 26.5945C116.802 26.6271 116.851 26.6703 116.889 26.7217C116.928 26.7731 116.956 26.8317 116.972 26.894C116.989 26.9563 116.992 27.0212 116.983 27.085C116.974 27.1487 116.952 27.21 116.919 27.2653C116.886 27.3207 116.843 27.369 116.791 27.4074C116.739 27.4459 116.681 27.4738 116.618 27.4895Z",
			fill: "#CCCCCC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.996 28.5819L106.915 31.6879C106.852 31.7043 106.787 31.7083 106.723 31.6995C106.66 31.6908 106.598 31.6695 106.542 31.6369C106.487 31.6043 106.438 31.5611 106.399 31.5097C106.361 31.4583 106.332 31.3998 106.316 31.3374C106.3 31.2751 106.297 31.2102 106.306 31.1464C106.315 31.0827 106.337 31.0214 106.369 30.9661C106.402 30.9107 106.446 30.8624 106.498 30.824C106.549 30.7855 106.608 30.7576 106.671 30.7419L118.752 27.6358C118.877 27.6044 119.01 27.6237 119.121 27.6896C119.232 27.7556 119.312 27.8628 119.345 27.9877C119.377 28.1127 119.358 28.2454 119.293 28.3567C119.228 28.468 119.121 28.549 118.996 28.5819Z",
			fill: "#CCCCCC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.389 33.2223C103.344 33.2223 104.118 32.4494 104.118 31.4959C104.118 30.5425 103.344 29.7695 102.389 29.7695C101.434 29.7695 100.66 30.5425 100.66 31.4959C100.66 32.4494 101.434 33.2223 102.389 33.2223Z",
			fill: "#E34C4C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.541 22.9717L102.091 26.4282C101.703 26.5276 101.29 26.469 100.945 26.2653C100.599 26.0616 100.349 25.7294 100.249 25.3415L97.4301 14.4099C97.3307 14.0219 97.3894 13.6103 97.5934 13.2654C97.7974 12.9206 98.1301 12.6706 98.5185 12.5703L111.968 9.11375C112.356 9.01431 112.769 9.07288 113.114 9.27659C113.46 9.48031 113.71 9.81254 113.811 10.2004L116.629 21.132C116.729 21.5201 116.67 21.9316 116.466 22.2765C116.262 22.6214 115.929 22.8714 115.541 22.9717Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.541 22.9717L102.091 26.4282C101.703 26.5276 101.29 26.469 100.945 26.2653C100.599 26.0616 100.349 25.7294 100.249 25.3415L97.4301 14.4099C97.3307 14.0219 97.3894 13.6103 97.5934 13.2654C97.7974 12.9206 98.1301 12.6706 98.5185 12.5703L111.968 9.11375C112.356 9.01431 112.769 9.07288 113.114 9.27659C113.46 9.48031 113.71 9.81254 113.811 10.2004L116.629 21.132C116.729 21.5201 116.67 21.9316 116.466 22.2765C116.262 22.6214 115.929 22.8714 115.541 22.9717ZM98.5629 12.7421C98.2202 12.8307 97.9267 13.0514 97.7467 13.3557C97.5667 13.6601 97.515 14.0233 97.6029 14.3656L100.421 25.2973C100.51 25.6394 100.731 25.9325 101.036 26.1121C101.341 26.2918 101.705 26.3434 102.048 26.2557L115.496 22.7995C115.839 22.7109 116.133 22.4902 116.313 22.1859C116.493 21.8815 116.544 21.5183 116.456 21.176L113.638 10.2443C113.549 9.90218 113.328 9.60913 113.024 9.42946C112.719 9.24979 112.355 9.19817 112.012 9.28592L98.5629 12.7421Z",
			fill: "#BCBCBC",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.296 12.7894L104.509 14.5339C104.449 14.5504 104.386 14.5438 104.331 14.5155C104.276 14.4872 104.235 14.4392 104.214 14.3812C104.204 14.3509 104.201 14.319 104.204 14.2874C104.207 14.2558 104.217 14.2251 104.233 14.1974C104.248 14.1696 104.269 14.1452 104.294 14.1258C104.319 14.1064 104.348 14.0923 104.379 14.0844L111.288 12.3086C111.567 12.4498 111.494 12.7386 111.296 12.7895L111.296 12.7894Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.597 13.9769L104.809 15.7214C104.75 15.7379 104.687 15.7313 104.632 15.703C104.577 15.6747 104.535 15.6267 104.515 15.5687C104.505 15.5384 104.502 15.5065 104.505 15.4749C104.508 15.4433 104.518 15.4126 104.533 15.3849C104.549 15.3571 104.57 15.3327 104.595 15.3133C104.62 15.2939 104.649 15.2798 104.68 15.2719L111.589 13.4961C111.868 13.6373 111.795 13.9261 111.597 13.977L111.597 13.9769Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.522 16.7743L101.451 17.3065C101.417 17.3151 101.382 17.3171 101.348 17.3122C101.314 17.3074 101.281 17.2959 101.251 17.2783C101.221 17.2607 101.195 17.2375 101.174 17.2099C101.154 17.1823 101.138 17.1508 101.13 17.1174L100.501 14.6773C100.492 14.6438 100.49 14.609 100.495 14.5748C100.5 14.5406 100.511 14.5077 100.529 14.478C100.546 14.4482 100.57 14.4222 100.597 14.4015C100.625 14.3807 100.656 14.3656 100.69 14.357L102.761 13.8246C102.829 13.8073 102.901 13.8175 102.961 13.853C103.021 13.8885 103.065 13.9463 103.082 14.0138L103.712 16.4545C103.72 16.4879 103.722 16.5227 103.717 16.5569C103.712 16.5911 103.701 16.624 103.683 16.6538C103.666 16.6835 103.642 16.7095 103.615 16.7303C103.587 16.751 103.556 16.7661 103.522 16.7747V16.7743Z",
			fill: "#C2C2C2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.196 16.4145L101.837 19.0768C101.777 19.0934 101.714 19.0868 101.659 19.0584C101.605 19.0301 101.563 18.9821 101.542 18.9241C101.533 18.8939 101.529 18.8619 101.532 18.8303C101.536 18.7987 101.545 18.7681 101.561 18.7403C101.576 18.7125 101.597 18.6882 101.622 18.6687C101.647 18.6493 101.676 18.6352 101.707 18.6273L112.188 15.9336C112.467 16.0748 112.394 16.3636 112.196 16.4145Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.512 17.6058L102.153 20.2682C102.094 20.2848 102.03 20.2782 101.976 20.2499C101.921 20.2215 101.879 20.1735 101.859 20.1156C101.849 20.0853 101.846 20.0533 101.849 20.0217C101.852 19.9901 101.862 19.9595 101.877 19.9317C101.893 19.9039 101.913 19.8796 101.939 19.8602C101.964 19.8407 101.993 19.8266 102.023 19.8187L112.505 17.125C112.784 17.2662 112.71 17.555 112.512 17.6059L112.512 17.6058Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.813 18.7934L102.454 21.4557C102.394 21.4723 102.331 21.4657 102.276 21.4374C102.222 21.409 102.18 21.361 102.159 21.3031C102.15 21.2728 102.146 21.2408 102.15 21.2092C102.153 21.1776 102.162 21.147 102.178 21.1192C102.193 21.0914 102.214 21.0671 102.239 21.0477C102.265 21.0282 102.293 21.0141 102.324 21.0062L112.805 18.3125C113.084 18.4537 113.011 18.7425 112.813 18.7934Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.129 19.9809L102.77 22.6432C102.711 22.6598 102.647 22.6532 102.593 22.6249C102.538 22.5965 102.496 22.5485 102.476 22.4906C102.466 22.4603 102.463 22.4283 102.466 22.3967C102.469 22.3651 102.479 22.3345 102.494 22.3067C102.51 22.2789 102.531 22.2546 102.556 22.2352C102.581 22.2157 102.61 22.2016 102.641 22.1937L113.122 19.5C113.401 19.6412 113.327 19.93 113.129 19.9809Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.43 21.1723L103.071 23.8346C103.012 23.8512 102.948 23.8446 102.894 23.8163C102.839 23.7879 102.797 23.7399 102.776 23.682C102.767 23.6517 102.764 23.6197 102.767 23.5881C102.77 23.5565 102.78 23.5259 102.795 23.4981C102.81 23.4703 102.831 23.446 102.857 23.4266C102.882 23.4071 102.911 23.393 102.941 23.3851L113.423 20.6914C113.702 20.8326 113.628 21.1214 113.43 21.1723Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.557 31.3879L102.811 30.8431C102.846 30.7688 102.813 30.6804 102.739 30.6457C102.665 30.6111 102.576 30.6434 102.541 30.7177L102.288 31.2625L101.742 31.0087C101.667 30.9741 101.579 31.0063 101.544 31.0807C101.509 31.155 101.542 31.2434 101.616 31.278L102.162 31.5318L101.908 32.0766C101.874 32.151 101.906 32.2394 101.98 32.274C102.055 32.3086 102.143 32.2764 102.178 32.2021L102.432 31.6572L102.978 31.911C103.052 31.9456 103.141 31.9134 103.175 31.8391C103.21 31.7648 103.178 31.6763 103.103 31.6417L102.557 31.3879Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.224 40.9233L111.678 36.5478C110.914 36.3985 110.24 35.9526 109.804 35.3078C109.369 34.6631 109.207 33.8722 109.355 33.1086L114.502 6.67221C114.651 5.90902 115.098 5.23619 115.744 4.80134C116.389 4.36648 117.182 4.20511 117.946 4.35264L138.922 8.42336L142.686 12.8326L137.669 38.6035C137.519 39.3667 137.073 40.0396 136.427 40.4745C135.781 40.9094 134.989 41.0708 134.224 40.9233Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.788 5.1798C117.243 5.07475 116.679 5.18966 116.219 5.49933C115.76 5.80899 115.442 6.28812 115.335 6.8316L110.188 33.268C110.083 33.8117 110.198 34.3749 110.508 34.834C110.818 35.2931 111.298 35.6106 111.843 35.7169L134.389 40.0924C134.933 40.1975 135.497 40.0825 135.957 39.7729C136.417 39.4632 136.735 38.9841 136.842 38.4406L141.781 13.0692L138.473 9.19417L117.788 5.1798Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.445 16.3919L124.18 14.3998C124.053 14.3751 123.941 14.3009 123.868 14.1935C123.795 14.0861 123.769 13.9543 123.793 13.8271C123.818 13.7 123.892 13.5878 124 13.5154C124.108 13.4429 124.24 13.4161 124.367 13.4409L134.632 15.433C134.759 15.4577 134.872 15.532 134.944 15.6394C135.017 15.7468 135.044 15.8785 135.019 16.0057C134.994 16.1329 134.92 16.245 134.812 16.3174C134.705 16.3899 134.573 16.4167 134.445 16.392L134.445 16.3919Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.114 18.3975L123.868 16.0209C123.74 15.9962 123.628 15.922 123.556 15.8146C123.483 15.7072 123.456 15.5754 123.481 15.4482C123.506 15.3211 123.58 15.2089 123.688 15.1365C123.795 15.064 123.927 15.0372 124.054 15.0619L136.3 17.4385C136.428 17.4632 136.54 17.5375 136.613 17.6449C136.685 17.7523 136.712 17.884 136.687 18.0112C136.662 18.1384 136.588 18.2505 136.481 18.3229C136.373 18.3954 136.241 18.4222 136.114 18.3975Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M133.221 22.6868L122.957 20.6948C122.829 20.67 122.697 20.6968 122.59 20.7693C122.482 20.8417 122.408 20.9538 122.383 21.081C122.358 21.2081 122.385 21.3399 122.458 21.4473C122.53 21.5547 122.643 21.6289 122.77 21.6536L133.035 23.6457C133.161 23.6685 133.292 23.6407 133.398 23.5682C133.504 23.4956 133.577 23.3843 133.602 23.2582C133.627 23.1322 133.6 23.0015 133.529 22.8946C133.458 22.7876 133.347 22.713 133.221 22.6868Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.892 24.6898L122.647 22.3132C122.583 22.3 122.518 22.2996 122.454 22.3118C122.391 22.3241 122.33 22.3489 122.276 22.3847C122.222 22.4205 122.176 22.4667 122.14 22.5205C122.104 22.5743 122.079 22.6347 122.067 22.6982C122.054 22.7617 122.055 22.827 122.068 22.8904C122.081 22.9537 122.107 23.0138 122.143 23.0672C122.18 23.1206 122.227 23.1662 122.281 23.2014C122.335 23.2365 122.396 23.2606 122.46 23.2721L134.706 25.6486C134.769 25.6618 134.835 25.6622 134.898 25.65C134.962 25.6377 135.022 25.6129 135.076 25.5771C135.13 25.5413 135.176 25.4952 135.212 25.4413C135.248 25.3875 135.273 25.3271 135.286 25.2636C135.298 25.2001 135.298 25.1348 135.284 25.0714C135.271 25.0081 135.246 24.948 135.209 24.8946C135.173 24.8412 135.126 24.7956 135.071 24.7604C135.017 24.7253 134.956 24.7013 134.892 24.6898Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.621 30.8958L121.356 28.9037C121.229 28.879 121.116 28.8048 121.044 28.6974C120.971 28.59 120.944 28.4582 120.969 28.331C120.994 28.2039 121.068 28.0917 121.176 28.0193C121.283 27.9469 121.415 27.92 121.543 27.9448L131.808 29.9369C131.935 29.9616 132.048 30.0359 132.12 30.1433C132.193 30.2507 132.22 30.3824 132.195 30.5096C132.17 30.6368 132.096 30.7489 131.988 30.8213C131.881 30.8938 131.749 30.9206 131.621 30.8959L131.621 30.8958Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M133.286 32.9014L121.04 30.5248C120.912 30.5001 120.8 30.4259 120.727 30.3185C120.655 30.2111 120.628 30.0793 120.653 29.9521C120.678 29.825 120.752 29.7128 120.859 29.6404C120.967 29.5679 121.099 29.5411 121.226 29.5659L133.472 31.9424C133.6 31.9671 133.712 32.0414 133.784 32.1488C133.857 32.2562 133.884 32.3879 133.859 32.5151C133.834 32.6423 133.76 32.7544 133.652 32.8268C133.545 32.8993 133.413 32.9261 133.286 32.9014Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.53 15.5781C120.467 15.7601 121.375 15.1488 121.557 14.2129C121.739 13.2769 121.127 12.3707 120.19 12.1888C119.252 12.0069 118.344 12.6181 118.162 13.5541C117.98 14.49 118.592 15.3962 119.53 15.5781Z",
			fill: "#E34C4C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.062 13.9671L120.598 13.6945C120.671 13.6573 120.701 13.5678 120.663 13.4947C120.626 13.4216 120.536 13.3925 120.463 13.4297L119.927 13.7023L119.654 13.1667C119.617 13.0936 119.527 13.0645 119.454 13.1017C119.381 13.1389 119.351 13.2284 119.389 13.3014L119.662 13.8371L119.125 14.1097C119.052 14.1468 119.023 14.2363 119.06 14.3094C119.097 14.3825 119.187 14.4116 119.26 14.3744L119.797 14.1018L120.07 14.6374C120.107 14.7105 120.197 14.7396 120.27 14.7024C120.343 14.6653 120.372 14.5758 120.335 14.5027L120.062 13.9671Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.314 21.5178C120.271 21.7404 120.184 21.9523 120.059 22.1414C119.934 22.3305 119.773 22.4931 119.584 22.62C119.396 22.7468 119.185 22.8354 118.962 22.8806C118.74 22.9259 118.51 22.9269 118.287 22.8837C118.273 22.8811 118.258 22.8777 118.244 22.8735C117.912 22.8001 117.609 22.6307 117.373 22.3863C117.137 22.1419 116.978 21.8334 116.917 21.4994C116.855 21.1654 116.894 20.8208 117.028 20.5086C117.162 20.1965 117.385 19.9307 117.669 19.7445C117.954 19.5583 118.287 19.4599 118.627 19.4618C118.967 19.4636 119.299 19.5655 119.581 19.7548C119.863 19.9441 120.084 20.2123 120.214 20.5259C120.345 20.8395 120.379 21.1845 120.314 21.5178Z",
			fill: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.694 30.0977C117.631 30.2796 118.539 29.6684 118.721 28.7324C118.903 27.7965 118.291 26.8902 117.354 26.7083C116.416 26.5264 115.509 27.1376 115.326 28.0736C115.144 29.0095 115.756 29.9157 116.694 30.0977Z",
			fill: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M142.575 12.9281L139.085 12.2509C138.831 12.2015 138.606 12.0531 138.461 11.8383C138.316 11.6235 138.262 11.3599 138.312 11.1056L138.813 8.53256C138.815 8.5213 138.82 8.51089 138.828 8.50251C138.836 8.49414 138.846 8.48814 138.857 8.48521C138.868 8.48228 138.88 8.48254 138.891 8.48595C138.902 8.48936 138.912 8.49578 138.919 8.50449L142.633 12.8282C142.641 12.8378 142.646 12.8498 142.647 12.8624C142.648 12.875 142.646 12.8877 142.639 12.8986C142.633 12.9096 142.623 12.9183 142.612 12.9235C142.6 12.9287 142.587 12.9303 142.575 12.9279L142.575 12.9281Z",
			fill: "#787878"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.214 42.2241C120.042 42.3371 119.831 42.3769 119.629 42.3348C119.427 42.2928 119.25 42.1723 119.137 41.9999L113.302 33.1171C113.189 32.9447 113.149 32.7345 113.191 32.5328C113.233 32.3311 113.353 32.1543 113.525 32.0414C113.698 31.9285 113.908 31.8887 114.11 31.9307C114.312 31.9728 114.489 32.0933 114.602 32.2657L120.437 41.1485C120.55 41.3209 120.591 41.531 120.549 41.7327C120.507 41.9345 120.387 42.1113 120.214 42.2241Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.382 33.3437C113.354 34.0173 112.148 34.3708 110.917 34.3595C109.687 34.3483 108.487 33.9727 107.469 33.2804C106.451 32.5881 105.661 31.6101 105.2 30.4701C104.738 29.33 104.624 28.0792 104.874 26.8757C105.124 25.6722 105.725 24.5701 106.602 23.7089C107.479 22.8476 108.592 22.2657 109.801 22.0369C111.01 21.8081 112.26 21.9426 113.393 22.4234C114.526 22.9043 115.492 23.7098 116.167 24.7381C116.616 25.421 116.925 26.1852 117.078 26.9872C117.232 27.7892 117.225 28.6133 117.059 29.4124C116.894 30.2115 116.572 30.97 116.112 31.6445C115.653 32.3191 115.065 32.8964 114.382 33.3437ZM108.405 24.2439C107.634 24.7491 107.03 25.4717 106.67 26.3202C106.31 27.1688 106.21 28.1053 106.383 29.0112C106.556 29.9171 106.994 30.7518 107.641 31.4097C108.289 32.0676 109.117 32.5192 110.02 32.7073C110.924 32.8955 111.863 32.8117 112.719 32.4667C113.574 32.1216 114.308 31.5308 114.827 30.7689C115.345 30.007 115.626 29.1082 115.633 28.1862C115.641 27.2642 115.374 26.3605 114.868 25.5892C114.188 24.5549 113.126 23.8321 111.914 23.5798C110.702 23.3275 109.44 23.5664 108.405 24.2439Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.542 31.51C109.455 33.3787 112.52 33.3463 114.388 31.4378C116.256 29.5292 116.22 26.4671 114.307 24.5984C112.394 22.7297 109.329 22.7621 107.461 24.6706C105.593 26.5792 105.629 29.6413 107.542 31.51Z",
			fill: "#BCBCBC",
			fillOpacity: .7
		})
	]
});
export default SvgUserInputMismatch;
